import { BoMItemActivityOutsourcedStatus } from 'services/APIs/InternalAPI/internal-api.contracts'

export function getOutsourceStatusColor(
  status?: BoMItemActivityOutsourcedStatus,
) {
  switch (status) {
    case BoMItemActivityOutsourcedStatus.Accepted:
      return 'success'
    case BoMItemActivityOutsourcedStatus.RequestForQuotationReceivedError:
      return 'error'
    case BoMItemActivityOutsourcedStatus.QuotationReceived:
    case BoMItemActivityOutsourcedStatus.RequestForQuotationReceived:
      return 'warning'
    case BoMItemActivityOutsourcedStatus.RequestForQuotationSent:
    case BoMItemActivityOutsourcedStatus.DocumentCreated:
      return 'info'
    default:
      return 'default'
  }
}
